import { render, staticRenderFns } from "./RoleForm.vue?vue&type=template&id=22346a00&"
import script from "./RoleForm.vue?vue&type=script&lang=js&"
export * from "./RoleForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports